import { Injectable } from '@angular/core';
// import { GraphQLResult, generateClient } from 'aws-amplify/api';

// import { graphqlOperation } from '@aws-amplify/api-graphql';
import { InputVendorDetails, VendorModel } from '../../model/vendor.modal';
import {
  countriesDataQueries,
  createVendorQueries,
  findVendorQueries,
  getVendorQueries,
  updateVendorQueries,
} from '../../graphql/vendor.queries';
import { AppConstants } from './app-constants';
import { environment } from '../../../../../../environments/environment';
import { MiscDataModel } from '../../model/miscData.model';

// const client = generateClient();


import Amplify, { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult} from "aws-amplify/lib/API/types";

//const client = generateClient();

let myAppConfig = environment.myAppConfig;

Amplify.configure(myAppConfig);


@Injectable({
  providedIn: 'root',
})
export class VendorService {
  created_date: string;
  updated_date: string;
  constructor() {
    this.created_date = this.localDateFormate();
    this.updated_date = this.localDateFormate();
  }

  localDateFormate() {
    // Assuming mydate is defined as a Date object
    const mydate = new Date();

    // Convert the date to ISO 8601 format including the local time zone offset
    const isoDateString = mydate.toISOString();

    // Alternatively, you can manually format the date string to include the local time zone offset
    const offset = -mydate.getTimezoneOffset(); // Get the offset in minutes
    const offsetHours = Math.floor(Math.abs(offset) / 60);
    const offsetMinutes = Math.abs(offset) % 60;
    const offsetSign = offset >= 0 ? '+' : '-';

    const formattedDateString = `${mydate.getFullYear()}-${this.padZero(
      mydate.getMonth() + 1
    )}-${this.padZero(mydate.getDate())}T${this.padZero(
      mydate.getHours()
    )}:${this.padZero(mydate.getMinutes())}:${this.padZero(
      mydate.getSeconds()
    )}${offsetSign}${this.padZero(offsetHours)}:${this.padZero(offsetMinutes)}`;
    console.log(formattedDateString); // Output: 2024-02-14T15:02:01+05:30
    return formattedDateString;
  }

  padZero(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }

  private QUERY_KEY = {
    LIST: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listCpVendorDetail}`,
    GET: `${AppConstants.getq}${environment.dbPrefix}${AppConstants.listCpVendorDetail}`,
    CREATE_OR_UPDATE: `${AppConstants.create}${environment.dbPrefix}${AppConstants.createOrUpdateCpVendorDetail}`,
    list_MiscData: `${AppConstants.list}${environment.dbPrefix}${AppConstants.listMiscData}`,
  };

  public async filterByVendor(vendorType: string): Promise<VendorModel> {
    const querylist = this.QUERY_KEY.LIST;
    console.log('querylist', querylist, vendorType);

    try {
      const operation = graphqlOperation(findVendorQueries.query, {
        vendor_type: vendorType,
      });

      // const response: GraphQLResult<{
      //   querylist: VendorModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult; 

      console.log('[VENDOR_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data.');
      }
    } catch (error) {
      console.error('Error fetching vendor request status:', error);
      throw error;
    }
  }

  public async getCountry(key: string): Promise<MiscDataModel> {
    const querylist = this.QUERY_KEY.list_MiscData;
    console.log('querylist', querylist, key);

    try {
      const operation = graphqlOperation(countriesDataQueries.query, {
        data_key: key,
      });

      // const response: GraphQLResult<{
      //   querylist: MiscDataModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult; 

      console.log('[GET_COUNTRY_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data in misc data.');
      }
    } catch (error) {
      console.error('Error fetching misc request status:', error);
      throw error;
    }
  }

  public async createVendor(createdObj: any): Promise<InputVendorDetails> {
    const querylist = this.QUERY_KEY.CREATE_OR_UPDATE;
    console.log('querylist', querylist, createdObj);

    try {
      const operation = graphqlOperation(createVendorQueries.mutation, {
        name: createdObj.name,
        email: createdObj.email,
        phone: createdObj.phone,
        address: createdObj.address,
        vendor_type: createdObj.vendor_type,
        is_active: createdObj.is_active,
        ex_data: createdObj.ex_data,
        created_date: AppConstants.getlocalDateFormate(),
        updated_date: AppConstants.getlocalDateFormate(),
      });

      // const response: GraphQLResult<{
      //   querylist: InputVendorDetails;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult; 

      console.log('[GET_COUNTRY_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data in create vendor.');
      }
    } catch (error) {
      console.error('Error fetching vendor request status:', error);
      throw error;
    }
  }

  public async updateVendor(updateObj: any): Promise<InputVendorDetails> {
    const querylist = this.QUERY_KEY.CREATE_OR_UPDATE;
    console.log('querylist', querylist, updateObj);

    try {
      const operation = graphqlOperation(updateVendorQueries.mutation, {
        id: updateObj.id,
        name: updateObj.name,
        email: updateObj.email,
        phone: updateObj.phone,
        address: updateObj.address,
        vendor_type: updateObj.vendor_type,
        is_active: updateObj.is_active,
        ex_data: updateObj.ex_data,
        updated_date: AppConstants.getlocalDateFormate(),
      });

      // const response: GraphQLResult<{
      //   querylist: InputVendorDetails;
      // }> = (await client.graphql(operation)) as any;


      const response = await API.graphql(operation) as GraphQLResult; 


      console.log('[GET_COUNTRY_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data in create vendor.');
      }
    } catch (error) {
      console.error('Error fetching vendor request status:', error);
      throw error;
    }
  }

  public async getVendorListService(): Promise<VendorModel> {
    const querylist = this.QUERY_KEY.LIST;
    console.log('querylist', querylist, querylist);
    try {
      const operation = graphqlOperation(getVendorQueries.query, {});

      // const response: GraphQLResult<{
      //   querylist: VendorModel;
      // }> = (await client.graphql(operation)) as any;

      const response = await API.graphql(operation) as GraphQLResult; 

      console.log('[VENDOR_RESPONSE]', response); // Log the entire response

      if (response.data) {
        console.log('Data:', response.data); // Log the data part of the response
        const returnResponse: any = response.data;
        console.log('Return Response:', returnResponse); // Log the extracted data
        // Access the property dynamically using square bracket notation
        const queryExplorerData = returnResponse[querylist];
        return queryExplorerData;
      } else {
        throw new Error('GraphQL operation returned no data vendor list.');
      }
    } catch (error) {
      console.error('Error fetching vendor list request status:', error);
      throw error;
    }
  }
}
